import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../../../i18n';

const app = document.getElementById('app');

ReactDOM.render(
  <App {...app.dataset} />,
  app
);
